<script setup lang="ts">
import { computed, inject, ref } from "vue";
import type { DynamicDialogOptions } from "primevue/dynamicdialogoptions";
import { MPdfViewer } from "@xlabmedical/medic-web-engine";

type PdfPreviewDialogParams = {
    src?: string;
    height?: string;
};

const dialogRef = inject("dialogRef") as DynamicDialogOptions;
const params = (dialogRef?.value?.data as PdfPreviewDialogParams) ?? {};

const assetUrl = ref(params.src ?? "");
const viewerHeight = computed(() => params.height);
</script>

<template>
    <MPdfViewer v-model:assetUrl="assetUrl" :height="viewerHeight" />
</template>
